import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_offsite_housing_sites_occupied_by_wrkrs_managed_and_cont'

export const dataPointDefinition = {
  retracedId: 'num_of_offsite_housing_sites_occupied_by_wrkrs_managed_and_cont',
  name: 'Number of off-site housing sites occupied by workers managed and controlled by an entity other than the facility:',
  description:
    'Off-site housing for this question shall mean dormitory-style housing where multiple workers are housed together in a structure that is NOT managed or controlled by the facility but by some other entity.\r\r\nThe facility does NOT own the building and does NOT pay the other entity managing the building any fees (fees may include fees for maintenance of the building or fees to house the workers). \r\r\n\r\r\nE.g., an apartment that is shared by multiple workers to save cost on housing should not be included in the scope of this question. However, a dormitory-style building not managed/controlled by the facility that houses multiple facility workers (e.g., different migrant workers working for multiple factories in the area) must be included in this question.  \r\r\n\r\r\nThe intent of this question is to understand the potential risk of facility workers living in housing that may be poorly managed by another entity. \r\r\n\r\r\nWorkers are persons working on/with the facility\'s product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them. Facilities include those involved in production of goods, and also those involved in operations related to the product, e.g. distribution. Examples of "workers" are cutters, sewers, QC, packers, etc. (all workers who contribute to produce the product), boiler workers, mechanics (machine repair persons), and workers who load product onto trucks.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bui-5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 820,
  sectionId: '2.2.9.10',
  impactArea: 'Accommodation & Dormitories',
  impactAreaId: 'ACCOMODATION_AND_DORMITORIES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
